import * as superagent from "superagent";

import {addNotification} from "./shared/modules/notification/actions/notificationsAction";
import {NOTIFICATION_ERROR} from "./shared/modules/notification/constants";
import * as auth from "./shared/actions/auth";


export const requestAuth = () => superagent
  .agent()
  .use(() => {
    if (!window.navigator.onLine) {
      addNotification(
        __("You are offline right now. Please check your internet connection and try again."),
        NOTIFICATION_ERROR
      );
      throw new Error('No connection');
    }
  })
  .auth(auth.getToken(), {type: 'bearer'})
  .set("Token", auth.getToken());
